<div [ngClass]="appConfig.layout.navbar.primaryBackground">
    <kavigation [navigation]="navigation" layout="horizontal"></kavigation>
</div>